import authConstants from "constants/authConstants";

const refreshToken = () => `${authConstants.AUTH_TOKEN_URL}refresh/`;
const login = () => authConstants.AUTH_TOKEN_URL;
const updatePassword = () => `${authConstants.AUTH_PASSWORD_RESET_URL}confirm/`;
const updateProfile = () => authConstants.UPDATE_PROFILE_URL;
const getProfileData = () => authConstants.GET_PROFILE_DATA_URL;
const getUsersOrganizationsUrl = () => authConstants.USERS_ORGANIZATIONS;
const getUsersUrl = (id = "") => `${authConstants.USERS_URL}${id}`;
const lockUsers = (userId) => `${authConstants.LOCK_USERS_URL}${userId}/`;
const activateUsers = (id) => `${authConstants.USERS_URL}${id}/`;
const resetPassword = () => authConstants.AUTH_PASSWORD_RESET_URL;
const sendEmail = (userId) => authConstants.SEND_EMAIL_URL(userId);

export default {
  refreshToken,
  login,
  updatePassword,
  updateProfile,
  getProfileData,
  getUsersUrl,
  lockUsers,
  activateUsers,
  resetPassword,
  sendEmail,
  getUsersOrganizationsUrl,
};
